
















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Input extends Vue {
  @Prop({ default: String }) value: any
  @Prop({ default: String }) type: any
  @Prop({ default: String }) placeholder: any
  @Prop({ default: false }) isNumber: any
  @Prop({ default: false }) disabled: any

  change() {
    this.$emit('change')
  }

  blur() {
    this.$emit('blur')
  }

  keyup(e: any) {
    if (this.isNumber) {
      const reg = /^-?[0-9]*(\.[0-9]*)?$/

      const { value } = e.target
      if (!isNaN(value) && reg.test(value)) {
        this.$emit('input', value)
      }
    } else {
      this.$emit('input', e.target.value)
    }
  }

  pressEnter() {
    this.$emit('pressEnter', this.value)
  }
}
